// src/services/materialCalculatorAPI.js

const API_BASE = "https://ideatorportal.in/api";

export async function fetchHeadings() {
  const res = await fetch(`${API_BASE}/get_headings.php`);
  return res.json();
}

export async function fetchMaterials() {
  const res = await fetch(`${API_BASE}/list_materials.php`);
  return res.json();
}

export async function fetchFormulas(headingId) {
  const res = await fetch(`${API_BASE}/get_formulas.php?heading_id=${headingId}`);
  return res.json();
}

export async function calculateMaterials(headingId, inputQty) {
  const res = await fetch(`${API_BASE}/calculate_materials.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ heading_id: headingId, input_qty: inputQty }),
  });
  return res.json();
}

export async function addHeading(data) {
  const res = await fetch(`${API_BASE}/add_heading.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return res.json();
}

export const addMaterial = async ({ name, unit, price_per_unit }) => {
  const res = await fetch(`${API_BASE}/add_material.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, unit, price_per_unit }),
  });
  return await res.json();
};

export const listMaterials = async () => {
  const res = await fetch(`${API_BASE}/list_materials.php`);
  return await res.json();
};

export const updateMaterial = async (id, name, unit, price) => {
  const res = await fetch('https://ideatorportal.in/api/update_materials.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, name, unit, price_per_unit: price }),
  });
  return await res.json();
};


export const addFormula = async (data) => {
    try {
      const response = await fetch('https://ideatorportal.in/api/add_formula.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      return await response.json();
    } catch (err) {
      console.error("Error adding formula:", err);
      return { success: false, message: "Failed to connect to server" };
    }
  };
  export const addFixedHeading = async (data) => {
    try {
      const res = await fetch('https://ideatorportal.in/api/add_fixed_heading.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      const result = await res.json();
      console.log(result); // Debug
      return result;
    } catch (error) {
      console.error('Fetch error:', error);
      return { success: false, message: 'Network or server error' };
    }
  };
  
  
  
  export const listFixedHeadings = async () => {
    try {
      const res = await fetch('https://ideatorportal.in/api/list_fixed_heading.php');
      const data = await res.json();
      if (Array.isArray(data)) {
        return data;
      } else {
        console.error('Invalid response format from API:', data);
        return []; // fallback if backend returns something unexpected
      }
    } catch (error) {
      console.error('Error in listFixedHeadings:', error);
      return []; // fallback if fetch fails
    }
  };
  
  
  export const updateFixedHeading = async (id, name, unit, price) => {
    const formData = new URLSearchParams();
    formData.append('id', id);
    formData.append('name', name);
    formData.append('unit', unit);
    formData.append('price_per_unit', price);
  
    const res = await fetch(`${API_BASE}/edit_fixed_heading.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString(),
    });
  
    return res.json();
  };
  export const listMakesForHeading = async (headingId) => {
    const res = await fetch(`https://ideatorportal.in/api/list_makes.php?heading_id=${headingId}`);
    return res.json();
  };
  
  export const addMakeForHeading = async (makeData) => {
    const res = await fetch('https://ideatorportal.in/api/add_make.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(makeData)
    });
    return res.json();
  };
  
  export const deleteMakeForHeading = async (makeId) => {
    await fetch(`https://ideatorportal.in/api/delete_make.php?id=${makeId}`, {
      method: 'DELETE'
    });
  };
  
  
  
